import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { safeLogEvent } from 'firebase.js';
import { isInWebView } from 'utils/nativeBridge';
import Modal from 'components/Modal';
import { StyledButton } from 'components/Button/style';
import { useTeamColors } from 'hooks';
import {
  PermissionContent,
  PermissionTitle,
  PermissionText,
  ButtonGroup,
} from './style';

export const LocationPermissionModal = ({
  show,
  onAllow,
  onMaybeLater,
  onDeny,
  isThirdPrompt = false,
}) => {
  const { mainColor } = useTeamColors();
  const isWebViewMode = isInWebView();

  // Freeze the button state when modal is shown to prevent text changing during fade
  const [frozenIsThirdPrompt, setFrozenIsThirdPrompt] = useState(isThirdPrompt);

  useEffect(() => {
    // Only update the frozen state when modal becomes visible
    if (show) {
      setFrozenIsThirdPrompt(isThirdPrompt);
    }
  }, [show, isThirdPrompt]);
  const handleAllow = (event) => {
    event.preventDefault();
    event.stopPropagation();
    safeLogEvent('location_permission_response', {
      response: 'allow',
      prompt_number: isThirdPrompt ? 3 : 'unknown',
    });
    onAllow();
  };

  const handleMaybeLater = (event) => {
    event.preventDefault();
    event.stopPropagation();
    safeLogEvent('location_permission_response', {
      response: 'maybe_later',
      prompt_number: isThirdPrompt ? 3 : 'unknown',
    });
    onMaybeLater();
  };

  const handleDeny = (event) => {
    event.preventDefault();
    event.stopPropagation();
    safeLogEvent('location_permission_response', {
      response: 'deny',
      prompt_number: 3,
    });
    onDeny();
  };

  return (
    <Modal
      disableClickOutside
      onClose={handleMaybeLater}
      show={show}
      showCloseBtn={false}
    >
      <PermissionContent>
        <PermissionTitle>
          {isWebViewMode
            ? 'Enable Location Services?'
            : 'Enable Location Services?'}
        </PermissionTitle>
        <PermissionText>
          {isWebViewMode
            ? "Get directions to events and personalized recommendations. The app will use your device's location services for accurate directions."
            : 'Get directions to events and personalized recommendations based on your location.'}
        </PermissionText>
        <ButtonGroup>
          <StyledButton $bgColor={mainColor} onClick={handleAllow}>
            Allow
          </StyledButton>
          {frozenIsThirdPrompt ? (
            <StyledButton $bgColor={mainColor} onClick={handleDeny}>
              Do Not Allow
            </StyledButton>
          ) : (
            <StyledButton $bgColor={mainColor} onClick={handleMaybeLater}>
              Maybe Later
            </StyledButton>
          )}
        </ButtonGroup>
      </PermissionContent>
    </Modal>
  );
};

LocationPermissionModal.propTypes = {
  isThirdPrompt: PropTypes.bool,
  onAllow: PropTypes.func.isRequired,
  onDeny: PropTypes.func.isRequired,
  onMaybeLater: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default LocationPermissionModal;
